import { COFFEE_PROMOTIONS } from "../../../../utils/constant";
import { CoffeeModuleCard } from "../../../../components/ui";
import styles from "./style.module.scss";

const CoffeePromotions = () => {
  return (
    <div className={styles.coffeePromotionsPage}>
      {COFFEE_PROMOTIONS.map((item) => (
        <CoffeeModuleCard key={item.id} {...item} />
      ))}
    </div>
  );
};

export default CoffeePromotions;
